<script lang="ts">
  export let success: boolean;
  export let stepNumber: number = 0;
  export let isActive: boolean = false;
</script>

<div class="container">
  {#if success}
    <img class="issue_icon" alt={`logo`} src="static/assets/icons/tick_success_icon.svg" />
  {:else if stepNumber}
    <div class="step {isActive && 'active'}">
      <span class="stepNumber {isActive && 'light'}">{stepNumber}</span>
    </div>
  {:else}
    <img class="issue_icon" alt={`logo`} src="static/assets/icons/issue_icon.svg" />
  {/if}
</div>

<style>
  .container {
    height: 36px;
    margin-right: 12px;
  }
  .issue_icon {
    height: 36px;
    width: 36px;
    margin-right: 12px;
  }

  .step {
    height: 36px;
    width: 36px;
    border-radius: 50%;
    background-color: var(--rekki-neutral-01);
    display: flex;
    justify-content: center;
    justify-items: center;
    align-items: center;
  }

  .stepNumber {
    text-align: center;
    color: var(--rekki-dark);
    font-size: 16px;
    font-weight: bold;
  }

  .light {
    color: var(--rekki-light);
  }
  .active {
    background-color: var(--rekki-neutral-04);
  }
</style>
